export class ClassItem {
  value: any;
  label?: string;
  imageId?: string;
  color?: string | string[];
  radius?: number;
  minValue?: number;
  maxValue?: number;
  hidden?: boolean;

  constructor(options: Partial<ClassItem>) {
    Object.assign(this, options);
  }
}
